(function(angular, schoolwork12) {
    'use strict';
 
    angular.module(schoolwork12.app.student.name)
    .directive('moveMenu', ['$document', 
                 function ($document) {
                    return {

                            restrict: 'A',
                            link: function(scope, element, attributes) {
    
                                var moveBtn = angular.element(document.querySelectorAll('.moveBtn'));
                                var $subMenu = $("#subMenu");
                                element.bind('click', function (event) {
                                    
                                    if (element.hasClass("termSelected")) {
                                       angular.element(moveBtn).addClass('moveCourses'); 
                                    }
                                    else {
                                          angular.element(moveBtn).removeClass('moveCourses');
                                          var slideArgs = {right: '0'};
                                          $subMenu.animate(slideArgs, 400);
                                    }
                                    scope.$apply();
                                });

                                $("#subMenu .moveYearSelected").on("click", function(){
                                    var slideArgs = {right: '-101%'};
                                    $subMenu.animate(slideArgs, 400);
                                    angular.element(moveBtn).removeClass('moveCourses');
                                });

                                $(".moveBtn").on("click", function(){
                                    var slideArgs = {right: '-101%'};
                                    $subMenu.animate(slideArgs, 400);
                                    angular.element(moveBtn).removeClass('moveCourses');
                                });
          
                            }
                        }
                    }
                ]);
    
}(angular, schoolwork12));







                          